export default [{
  path: '/funcoes',
  component: {
    name: 'funcoesBase',
    template: '<router-view />',
    meta: {
      resource: 'funcao',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'funcoes',
    component: () => import('@/app-modulo/comuns/funcao/FuncaoView.vue'),
    meta: {
      resource: 'funcao',
      action: 'read',
      navActiveLink: 'funcoes',
      pageTitle: 'Cadastro de funções',
      breadcrumb: [
        {
          text: 'Funções',
          to: { name: 'funcoes' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-funcao',
    component: () => import('@/app-modulo/comuns/funcao/shared/components/cadastro/Funcao.vue'),
    meta: {
      resource: 'funcao',
      action: 'create',
      navActiveLink: 'funcoes',
      pageTitle: 'Cadastro de funções',
      breadcrumb: [
        {
          text: 'Funções',
          to: { name: 'funcoes' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-funcao' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-funcao',
    component: () => import('@/app-modulo/comuns/funcao/shared/components/cadastro/Funcao.vue'),
    meta: {
      resource: 'funcao',
      action: 'update',
      navActiveLink: 'funcoes',
      pageTitle: 'Cadastro de funções',
      breadcrumb: [
        {
          text: 'Funções',
          to: { name: 'funcoes' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-funcao' },
          active: true,
        },
      ],
    },
  }],
}]
